const videoTemplate = (styleClass, id) =>
  `<iframe allowfullscreen class="${styleClass}" frameborder="0" height="360" width="640" src="https://www.youtube-nocookie.com/embed/${id}?rel=0&amp;amp;controls=1&amp;amp;showinfo=0&amp;amp;autoplay=1"></iframe>`;

const storyVideoTemplate = () => videoTemplate("story-video", "KpuWiCB49_0");

const sleeponitVideoTemplate = () =>
  videoTemplate("sleeponit-video", "jSXd7X1F-LY");

const truthVideoTemplate = () => videoTemplate("truth-video", "6hX_BWxSnSI");

const unboxingVideoTemplate = () =>
  videoTemplate("unboxing-video", "VNvu9XjN_b8");

const getVideoTemplate = name => {
  let templateFunction = {
    sheets_video: storyVideoTemplate,
    sleeponit_video: sleeponitVideoTemplate,
    story_video: storyVideoTemplate,
    truth_video: truthVideoTemplate,
    unboxing_video: unboxingVideoTemplate
  }[name]; 

  return `<a data-id="close" href="#"></a>${templateFunction()}`;
};

export { getVideoTemplate };